import parse from 'html-react-parser'
import styles from './Quote.module.scss'
import Heading from '../Heading/Heading'
import { RichTextType } from '~types'
import { Eyebrow } from '~elements'
import { unwrapSingleParagraph } from '../../../utils'

interface QuoteProps {
  classification: {
    quoteTitle: string
    quoteDescription: RichTextType
    quoteSubHeadline: string
    quoteCopy: RichTextType
  }
}

const Quote = ({ classification }: QuoteProps) => (
  <blockquote className={styles['quote']}>
    <Heading level={2} noMarginBottom noMarginTop>
      <span>{classification?.quoteTitle}</span>{' '}
      {classification?.quoteDescription?.html && unwrapSingleParagraph(classification.quoteDescription.html)}
    </Heading>
    <div className={styles['sub-headline']}>
      <Heading level={4} color='accent' noMarginBottom>
        {classification?.quoteSubHeadline}
      </Heading>

      {classification?.quoteCopy?.html && (
        <Eyebrow
          color='lightest'
          title={unwrapSingleParagraph(classification.quoteCopy.html)}
          size='md'
          noMarginBottom
        />
      )}
    </div>
  </blockquote>
)

export default Quote
